;(window as any).__VUE_OPTIONS_API__ = false
;(window as any).__VUE_PROD_DEVTOOLS__ = false
;(window as any).__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false
